// import cookies from 'js-cookie'
// import { useQuery } from 'react-query'
import dynamic from 'next/dynamic'
// import MobileNavigationOverlayV2 from '../HeaderV2/MobileNavigationOverlayV2'
import Slider from './slider'
// import MobileNavigationOverlay from './mobile-navigation-overlay'
// import MobileSearchOverlay from './mobile-search-overlay'
// import LoggedInSideBar from './logged-in-sidebar'

import type { MobileOverlayStateType } from './utils/types'
import MoreMobileOverlay from './more-mobile-overlay'
// import { BETA_INDSTOCKS_HOST, INDSTOCKS_HOST } from '@/root/constants/common'
// import { USER_POC_URL } from '@/root/constants'
// import { getFetchRequest } from '@/root/utils/network-adapter/fetch-request'

const LoggedInSideBar = dynamic(() => import('./logged-in-sidebar'), {
  ssr: false,
})
const MobileSearchOverlay = dynamic(() => import('./mobile-search-overlay'), {
  ssr: false,
})
const WatchlistSidebar = dynamic(() => import('./watchlist-sidebar'), {
  ssr: false,
})
// const MobileNavigationOverlayV2 = dynamic(
//   () => import('../HeaderV2/MobileNavigationOverlayV2'),
//   {
//     ssr: true,
//   },
// )

type SidebarToggler = () => void

export default function SliderNav({
  overlay,
  isAuthenticated,
  toggleLoggedInSidebarOverlay,
  toggleSearchOverlay,
  // toggleNavOverlay,
  toggleMoreOverlay,
  toggleWatchlistOverlay,
  data,
  host, // isInMobile,
}: {
  overlay: MobileOverlayStateType
  isAuthenticated: boolean
  toggleLoggedInSidebarOverlay: SidebarToggler
  toggleSearchOverlay: SidebarToggler
  // toggleNavOverlay: SidebarToggler
  toggleMoreOverlay: SidebarToggler
  toggleWatchlistOverlay: SidebarToggler
  host: string

  data: {
    firstName?: string
    lastName?: string
    isSubscribed: boolean
    subscription_plan?: string | null
    profileData?: unknown
  }
  // isInMobile?: boolean
  // setOverlay: Dispatch<SetStateAction<MobileOverlayStateType>>
}) {
  // const authenticationToken = cookies.get('token')
  // const headers = { Authorization: `Bearer ${authenticationToken}` }

  // const { data: pocData } = useQuery(
  //   'user-poc',
  //   () =>
  //     getFetchRequest({
  //       url: USER_POC_URL,
  //       config: {
  //         headers,
  //       },
  //     }),
  //   {
  //     enabled: !!authenticationToken,
  //     staleTime: Infinity,
  //   },
  // )

  return (
    <Slider
      overlay={overlay}
      isAuthenticated={isAuthenticated}
      showOverlay={
        isAuthenticated &&
        (overlay === 'logged-in-sidebar-overlay' ||
          (typeof overlay === 'object' &&
            overlay?.type === 'logged-in-watchlist-overlay'))
      }
      onOverlayClick={() => {
        if (overlay === 'logged-in-sidebar-overlay') {
          toggleLoggedInSidebarOverlay()
        } else if (
          typeof overlay === 'object' &&
          overlay?.type === 'logged-in-watchlist-overlay'
        ) {
          toggleWatchlistOverlay()
        }
      }}
    >
      {overlay === 'search-overlay' && (
        <div className="h-full">
          <MobileSearchOverlay closeOverlay={toggleSearchOverlay} host={host} />
        </div>
      )}
      {overlay === 'more-overlay' && (
        <div className="h-full">
          <MoreMobileOverlay isOpen={true} onClose={toggleMoreOverlay} />
        </div>
      )}
      {/* {isInMobile && (
        <div className="">
          {host === INDSTOCKS_HOST || host === BETA_INDSTOCKS_HOST ? (
            <MobileNavigationOverlay
              closeOverlay={toggleNavOverlay}
              host={host}
              isOpen={overlay === 'nav-overlay'}
              setOverlay={setOverlay}
            />
          ) : (
            <MobileNavigationOverlayV2
              closeOverlay={toggleNavOverlay}
              isOpen={overlay === 'nav-overlay'}
              isAuthenticated={isAuthenticated}
            />
          )}
        </div>
      )} */}

      {overlay === 'logged-in-sidebar-overlay' && (
        <LoggedInSideBar
          onCloseClick={toggleLoggedInSidebarOverlay}
          firstName={data.firstName}
          lastName={data.lastName}
          isSubscribed={data.isSubscribed}
          subscription_plan={data.subscription_plan}
          profileData={data.profileData}
          // showPOCLink={!!pocData?.data?.length}
        />
      )}
      {typeof overlay === 'object' &&
        overlay?.type === 'logged-in-watchlist-overlay' && (
          <WatchlistSidebar
            closeOverlay={toggleWatchlistOverlay}
            overlay={overlay}
          />
        )}
    </Slider>
  )
}
